export default "__VITE_ASSET__BF6wZb6h__"